
    <ng-container #entryPoint></ng-container>
    <router-outlet></router-outlet>
  